module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard.index'
      }
    }
  }, [_c('img', {
    staticClass: "brand",
    attrs: {
      "src": require("../../../static/img/logo-white.svg"),
      "alt": "logo",
      "width": "180px"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [(_vm.user_permission.data.dashboard) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "id": "sidebar-dashboard",
      "data-intro": "Get a birds eye view of all important metrics.",
      "data-position": "right",
      "tag": "li",
      "to": {
        name: 'dashboard.index'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "arrow invisible"
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-home"
  })])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.status == 2) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'dashboard.companylist'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("Login As Company")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "far fa-newspaper"
  })])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "id": "sidebar-calendar",
      "tag": "li",
      "title": "Schedule Calendar",
      "to": {
        name: 'schedule_calendar'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("Calendar")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt"
  })])]), _vm._v(" "), (_vm.user_permission.data.campaign_create || _vm.user_permission.data.campaign_view || _vm.user_permission.data.campaign_schedule) ? _c('li', {
    attrs: {
      "id": "sidebar-campaign",
      "data-intro": "Create and manage Phishing simulation campaigns.",
      "data-position": "right"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.campaign_create) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/campaigns/create'),
    attrs: {
      "tag": "li",
      "to": {
        name: 'campaigns.create'
      }
    }
  }, [_c('a', [_vm._v("Add Campaign")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'create_needle_phishing'
      }
    }
  }, [_c('a', [_vm._v("Add Needle Phishing")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.campaign_view) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/campaigns'),
    attrs: {
      "tag": "li",
      "to": {
        name: 'campaigns'
      }
    }
  }, [_c('a', [_vm._v("View Campaign")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.campaign_schedule) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'bulk_campaigns'
      }
    }
  }, [_c('a', [_vm._v("Schedule Campaigns")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/campaigns/creator-workspace'
      }
    }
  }, [_c('a', [_vm._v("Campaigns Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/campaigns/approver-workspace'
      }
    }
  }, [_c('a', [_vm._v("Campaigns Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_create || _vm.user_permission.data.announcement_view) ? _c('li', {
    attrs: {
      "id": "sidebar-announcement",
      "data-intro": "Use this to create and manage Announcements, eAUP or internal communication.",
      "data-position": "right"
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.announcement_create) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/announcements/create'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/announcements/create'
      }
    }
  }, [_c('a', [_vm._v("Add Announcement")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_view) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/announcements'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/announcements'
      }
    }
  }, [_c('a', [_vm._v("View Announcement")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/announcements/creator-workspace'
      }
    }
  }, [_c('a', [_vm._v("Announcement Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/announcements/approver-workspace'
      }
    }
  }, [_c('a', [_vm._v("Announcement Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_create || _vm.user_permission.data.policy_view) ? _c('li', {
    attrs: {
      "id": "sidebar-policy",
      "data-intro": "Policy",
      "data-position": "right"
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.policy_create) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/policy/create'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/policy/create'
      }
    }
  }, [_c('a', [_vm._v("Add Policy")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_view) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/policy'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/policy'
      }
    }
  }, [_c('a', [_vm._v("View Policy")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/policy/creator-workspace'
      }
    }
  }, [_c('a', [_vm._v("Policy Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        path: '/policy/approver-workspace'
      }
    }
  }, [_c('a', [_vm._v("Policy Workspace")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.adobeAcrobatStatus) ? _c('li', {
    attrs: {
      "id": "adobe_acrobat",
      "data-intro": "adobe_acrobat",
      "data-position": "right"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/add-agreement'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/add-agreement'
      }
    }
  }, [_c('a', [_vm._v("Add Agreement")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/view-agreements'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/view-agreements'
      }
    }
  }, [_c('a', [_vm._v("View Agreement")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/adobe-auth'),
    attrs: {
      "tag": "li",
      "to": {
        path: '/adobe-auth'
      }
    }
  }, [_c('a', [_vm._v("Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_scenario || _vm.user_permission.data.add_scenario) ? _c('li', {
    attrs: {
      "id": "sidebar-scenario",
      "data-intro": "Create and manage Scenarios for Phishing Simulation and Announcement campaigns.",
      "data-position": "right"
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.add_scenario) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/scenario/description'),
    attrs: {
      "tag": "li",
      "to": {
        name: 'scenario.description'
      }
    }
  }, [_c('a', [_vm._v("Add Scenario")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_scenario) ? _c('router-link', {
    staticClass: "hide_after_click",
    class: _vm.checkActive(_vm.$route.path === '/scenario'),
    attrs: {
      "tag": "li",
      "to": {
        name: 'scenario'
      }
    }
  }, [_c('a', [_vm._v("View Scenarios")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_modules || _vm.user_permission.data.upload_modules || _vm.user_permission.data.direct_learning_management || _vm.user_permission.data.education_uploader || _vm.user_permission.data.is_education_editable) ? _c('li', {
    attrs: {
      "id": "sidebar-training"
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.is_education_editable) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'trainingmoduleAdmin'
      }
    }
  }, [_c('a', [_vm._v("View Training (Super Admin)")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_modules) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'trainingmodule'
      }
    }
  }, [_c('a', [_vm._v("View Training")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.upload_modules) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'bulkeducation'
      }
    }
  }, [_c('a', [_vm._v("Upload Training")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.settings) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'training_settings'
      }
    }
  }, [_c('a', [_vm._v("Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.lms) ? _c('li', {
    attrs: {
      "id": "sidebar-lms",
      "oncontextmenu": "return false;"
    },
    on: {
      "click": function($event) {
        _vm.redirectToLms()
      }
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('li', {
    staticClass: "AIIcon",
    attrs: {
      "id": "sidebar-lms",
      "oncontextmenu": "return false;"
    },
    on: {
      "click": function($event) {
        _vm.redirectToHFv3()
      }
    }
  }, [_vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_recepients || _vm.user_permission.data.add_new_recepients || _vm.user_permission.data.manage_groups || _vm.user_permission.data.add_suppression || _vm.user_permission.data.view_suppression) ? _c('li', {
    attrs: {
      "id": "sidebar-recipients",
      "data-intro": "Manage your recipients here.",
      "data-position": "right"
    }
  }, [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.view_recepients) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'recipients'
      }
    }
  }, [_c('a', [_vm._v("View Recipients")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.add_new_recepients) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'recipients.imports'
      }
    }
  }, [_c('a', [_vm._v("Add New Recipients")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.manage_groups) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'recipients.manage_groups'
      }
    }
  }, [_c('a', [_vm._v("Manage Groups")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("M")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_suppression) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'recipients.suppression.imports'
      }
    }
  }, [_c('a', [_vm._v("Suppression List")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.add_suppression) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'suppression'
      }
    }
  }, [_c('a', [_vm._v("Suppressed Recipients")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_recepients && _vm.ouSettingStatus) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'recipients.ouSetting'
      }
    }
  }, [_c('a', [_vm._v("OU Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("O")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.phishing_campaigns_new || _vm.user_permission.data.announcement_campaigns_new || this.user_permission.data.policy_announcement_new || _vm.user_permission.data.leaderboard_new || _vm.user_permission.data.laggardsnew || _vm.user_permission.data.all_reports) ? _c('li', {
    attrs: {
      "id": "sidebar-reports-new"
    }
  }, [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.phishing_campaigns_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'reports.phishingcampaignsperformance'
      }
    }
  }, [_c('a', [_vm._v("Phishing Campaigns")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_campaigns_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'reports.announcementcampaignsperformance'
      }
    }
  }, [_c('a', [_vm._v("Announcement Campaigns")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_announcement_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'reports.policyannouncementperformance'
      }
    }
  }, [_c('a', [_vm._v("Policy Announcement")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.leaderboard_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'reports.leaderboard'
      }
    }
  }, [_c('a', [_vm._v("Leaderboard")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.laggardsnew) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'reports.laggards'
      }
    }
  }, [_c('a', [_vm._v("Laggards")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.detailed_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'report.campaigns-detailed-report'
      }
    }
  }, [_c('a', [_vm._v("Detailed")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_departments_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.repeatoffenders'
      }
    }
  }, [_c('a', [_vm._v("Repeatedly Phished Users ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("R")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.vulnerability_trend_new || _vm.user_permission.data.awareness_trend_new || _vm.user_permission.data.reporting_trend_new || _vm.user_permission.data.weakest_links_new || _vm.user_permission.data.strongest_links_least_compromised_new || _vm.user_permission.data.strongest_links_most_compromised_new || _vm.user_permission.data.weakest_departments_new) ? _c('li', {
    attrs: {
      "id": "sidebar-management-reports"
    }
  }, [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.vulnerability_trend_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.phishingvulnerabilitytrend'
      }
    }
  }, [_c('a', [_vm._v("Vulnerability Trend")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.awareness_trend_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.cybersecurityawarenesstrend'
      }
    }
  }, [_c('a', [_vm._v("Awareness Trend")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.reporting_trend_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.phishingreportingtrend'
      }
    }
  }, [_c('a', [_vm._v("Reporting Trend")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("R")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_links_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.weakestlinks'
      }
    }
  }, [_c('a', [_vm._v("Weakest Links")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("W")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.strongest_links_least_compromised_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.strongestlinks-least-compromised'
      }
    }
  }, [_c('a', [_vm._v("Strongest Links (Least Compromised)")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.strongest_links_most_compromised_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.strongestlinks-most-reported'
      }
    }
  }, [_c('a', [_vm._v("Strongest Links (Most Reported)")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_departments_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.weakestdepartments'
      }
    }
  }, [_c('a', [_vm._v("Weakest Departments ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("W")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.departments_new || _vm.user_permission.data.designations_new) ? _c('li', {
    attrs: {
      "id": "sidebar-vulnerability-reports"
    }
  }, [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.departments_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'newreports.VulnerabilityReport-DepartmentWiseUniqueEmployees'
      }
    }
  }, [_c('a', [_vm._v("Departments")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.designations_new) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'newreports.VulnerabilityReport-DesignationWiseUniqueEmployees'
      }
    }
  }, [_c('a', [_vm._v("Designations")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.organisation_vcro || _vm.user_permission.data.departments_vcro || _vm.user_permission.data.groups_vcro || _vm.user_permission.data.users_vcro) ? _c('li', {
    attrs: {
      "id": "sidebar-vcro"
    }
  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.organisation_vcro) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Risk Score of the Organisation.",
      "tag": "li",
      "to": {
        name: 'vcro.organisation_risk_score'
      }
    }
  }, [_c('a', [_vm._v(" Organisation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("O")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.departments_vcro) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Risk Score of all the departments of the organisation.",
      "tag": "li",
      "to": {
        name: 'vcro.all_department_risk_score'
      }
    }
  }, [_c('a', [_vm._v(" Departments")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.groups_vcro) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Risk Score of all the groups of the organisation.",
      "tag": "li",
      "to": {
        name: 'vcro.all_group_risk_score'
      }
    }
  }, [_c('a', [_vm._v(" Groups")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("G")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.users_vcro) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Risk Score of all the users of the organisation.",
      "tag": "li",
      "to": {
        name: 'vcro.all_user_risk_score'
      }
    }
  }, [_c('a', [_vm._v(" Users ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("U")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_add_badgee || _vm.user_permission.data.gamification_award_log || _vm.user_permission.data.gamification_badges || _vm.user_permission.data.gamification_set_points) ? _c('li', {
    attrs: {
      "id": "sidebar-gamification"
    }
  }, [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.gamification_badges) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "",
      "tag": "li",
      "to": {
        name: 'gamification.badges'
      }
    }
  }, [_c('a', [_vm._v("Badges")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("B")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_add_badgee) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "",
      "tag": "li",
      "to": {
        name: 'gamification.add_badge'
      }
    }
  }, [_c('a', [_vm._v("Add Badge")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("B")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_award_log) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "",
      "tag": "li",
      "to": {
        name: 'gamification.award_log_all'
      }
    }
  }, [_c('a', [_vm._v("Award Log")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_set_points) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "",
      "tag": "li",
      "to": {
        name: 'gamification.points'
      }
    }
  }, [_c('a', [_vm._v("Set Points")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_set_points) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "",
      "tag": "li",
      "to": {
        name: 'gamification.gamification_notification'
      }
    }
  }, [_c('a', [_vm._v("Notification Emails")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("N")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.myUserportal || _vm.user_permission.data.myUserportal_view_as || _vm.user_permission.data.customise_user_portal || _vm.user_permission.data.customise_login_page || _vm.user_permission.data.news_updates) && (_vm.showBoth || _vm.user_permission.data.userportal_active_version.userportal === 'v1')) ? _c('li', [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.myUserportal) ? _c('li', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "My User Portal",
      "tag": "li"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.myUserportal
    }
  }, [_vm._v("My User Portal")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "View As",
      "tag": "li",
      "to": {
        name: 'viewas'
      }
    }
  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_user_portal) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Customise User Portal",
      "tag": "li",
      "to": {
        name: 'customize'
      }
    }
  }, [_c('a', [_vm._v("Customise User Portal")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_login_page) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Customise Login Page",
      "tag": "li",
      "to": {
        name: 'customize_login'
      }
    }
  }, [_c('a', [_vm._v("Customise Login Page")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.news_updates) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "News Updates",
      "tag": "li",
      "to": {
        name: 'news_updates'
      }
    }
  }, [_c('a', [_vm._v("News Updates")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("N")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.myUserportal || _vm.user_permission.data.myUserportal_view_as || _vm.user_permission.data.customise_user_portal || _vm.user_permission.data.customise_login_page || _vm.user_permission.data.news_updates || _vm.user_permission.data.all_reports) && (_vm.showBoth || _vm.user_permission.data.userportal_active_version.userportal === 'v2')) ? _c('li', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "View As",
      "tag": "li",
      "to": {
        name: 'viewasNew'
      }
    }
  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Customise User Portal",
      "tag": "li",
      "to": {
        name: 'customize_new'
      }
    }
  }, [_c('a', [_vm._v("Customise User Portal")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_login_page) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Customise Login Page",
      "tag": "li",
      "to": {
        name: 'customize_login_new'
      }
    }
  }, [_c('a', [_vm._v("Customise Login Page")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.news_updates) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "News Updates",
      "tag": "li",
      "to": {
        name: 'news_updates_new',
      }
    }
  }, [_c('a', [_vm._v("News Updates")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("N")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.all_reports) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Portal Logins",
      "tag": "li",
      "to": {
        name: 'report.userportaltraffic'
      }
    }
  }, [_c('a', [_vm._v("Portal Traffic")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("PL")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.exported) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "Exported Files",
      "tag": "li",
      "id": "exported_files",
      "to": {
        name: 'report.exported_files'
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "sidebar-user-portal",
      "href": "javascript:;",
      "title": "Exported Files"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("Exported Files "), _c('sup', [_vm._v("New")])])]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-file-alt"
  })])]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.my_team_portal || _vm.user_permission.data.customise_team_portal || _vm.user_permission.data.team_portal_view_as) && (_vm.isAdmin == 2 || (_vm.teamPortalStatus.is_active_teamportal && _vm.teamPortalStatus.is_team_flag))) ? _c('li', {
    attrs: {
      "id": "teamportal"
    }
  }, [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.team_portal_view_as) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "title": "View As",
      "tag": "li",
      "to": {
        name: 'viewasTeamportal'
      }
    }
  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_team_portal) ? _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usersType != '3'),
      expression: "usersType!='3'"
    }],
    staticClass: "hide_after_click",
    attrs: {
      "title": "Customise Team Portal",
      "tag": "li",
      "to": {
        name: 'customizeTeamportal'
      }
    }
  }, [_c('a', [_vm._v("Customise Team Portal")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.status == 2) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "id": "admin_log",
      "tag": "li",
      "title": "Admin Activity Logs",
      "to": {
        name: 'adminLogs'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Admin Logs")]), _vm._v(" "), _c('span', {
    staticClass: "arrow invisible"
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-list"
  })])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domain || _vm.user_permission.data.general || _vm.user_permission.data.user_management || _vm.user_permission.data.retest_frequency || _vm.user_permission.data.email_setting || _vm.user_permission.data.throttling_speed || _vm.user_permission.data.data_entry_oops_page || _vm.user_permission.data.landing_page_templates || _vm.user_permission.data.notifications || _vm.user_permission.data.ignore_ip_list || _vm.user_permission.data.passing_percentage || _vm.user_permission.data.leaderboard_settings || _vm.user_permission.data.training_login_template || _vm.user_permission.data.security || _vm.user_permission.data.change_password || _vm.user_permission.data.import_reporters) ? _c('li', {
    attrs: {
      "id": "sidebar-settings",
      "data-intro": "Manage all company settings from here.",
      "data-position": "right"
    }
  }, [_vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.general) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'general'
      }
    }
  }, [_c('a', [_vm._v("General")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("G")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'customizeAdminLogin'
      }
    }
  }, [_c('a', [_vm._v("Admin Login Page")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'company.domains'
      }
    }
  }, [_c('a', [_vm._v("Domains  ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'appCredentials'
      }
    }
  }, [_c('a', [_vm._v("Channel Credentials")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'O365Setup'
      }
    }
  }, [_c('a', [_vm._v("O365 Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("O")])]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'aiSettings'
      }
    }
  }, [_c('a', [_vm._v("AI Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.email_settings) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'email'
      }
    }
  }, [_c('a', [_vm._v("Email Settings")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("E")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.email_settings) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'credentials'
      }
    }
  }, [_c('a', [_vm._v("Reply To - Credentials")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("R")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.throttling_speed) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'throttling_sending_speed'
      }
    }
  }, [_c('a', [_vm._v("Throttling Speed")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("T")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.auto_reminder_mail) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'trainingmail'
      }
    }
  }, [_c('a', [_vm._v("Auto Reminder Mail")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.user_management) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'usermanagement'
      }
    }
  }, [_c('a', [_vm._v("User Management")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.data_entry_oops_page) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'oopspage'
      }
    }
  }, [_c('a', [_vm._v("Data Entry Oops Page")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.landing_page_templates) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'master_landing'
      }
    }
  }, [_c('a', [_vm._v("Landing Page Templates")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.import_trained_users) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'import_trained_users'
      }
    }
  }, [_c('a', [_vm._v("Import Trained Users")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.notifications) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'notifications'
      }
    }
  }, [_c('a', [_vm._v("Notifications")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("N")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.ignore_ip_list) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'ignore_list'
      }
    }
  }, [_c('a', [_vm._v("Ignore IP List")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.passing_percentage) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'books'
      }
    }
  }, [_c('a', [_vm._v("Passing Percentage")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'training_languages'
      }
    }
  }, [_c('a', [_vm._v("Training Languages")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("T")])]), _vm._v(" "), (_vm.user_permission.data.security) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'security'
      }
    }
  }, [_c('a', [_vm._v("Security")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.import_reporters) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'import_reporters'
      }
    }
  }, [_c('a', [_vm._v("Import Reporters")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.change_password) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'changepassword'
      }
    }
  }, [_c('a', [_vm._v("Change Password")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.isActivePdfCampaign) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'pdfCampaign'
      }
    }
  }, [_c('a', [_vm._v("PDF Campaign")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'campaignUserRole'
      }
    }
  }, [_c('a', [_vm._v("Campaign User Role")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "id": "ip_information",
      "data-intro": "ip_information",
      "data-position": "right"
    }
  }, [_vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'ip.index'
      }
    }
  }, [_c('a', [_vm._v("Campaigns IP")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("C")])]), _vm._v(" "), _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'ip.announcementIp'
      }
    }
  }, [_c('a', [_vm._v("Announcements IP")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])])], 1)]), _vm._v(" "), (_vm.user_permission.data.ad_servers || _vm.user_permission.data.active_directory_view_logs) ? _c('li', {
    attrs: {
      "id": "active_directory_nav",
      "data-intro": "Manage Active Directory settings here!",
      "data-position": "right"
    }
  }, [_vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.ad_servers) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'listad'
      }
    }
  }, [_c('a', [_vm._v("AD Servers")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.active_directory_view_logs) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'alladlogs'
      }
    }
  }, [_c('a', [_vm._v("View Logs")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("V")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.azure_active_directory_authorization) ? _c('li', {
    attrs: {
      "id": "sidebar-azure-active-dir",
      "data-intro": "Manage Azure Active Dir settings here!",
      "data-position": "right"
    }
  }, [_vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.user_permission.data.azure_active_directory_authorization) ? _c('router-link', {
    staticClass: "hide_after_click",
    attrs: {
      "tag": "li",
      "to": {
        name: 'azure'
      }
    }
  }, [_c('a', [_vm._v("Authorization")]), _vm._v(" "), _c('span', {
    staticClass: "icon-thumbnail"
  }, [_vm._v("A")])]) : _vm._e()], 1)]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebarCollapse",
    attrs: {
      "aria-label": "Pin Menu",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "pg-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Campaigns")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "far fa-newspaper"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Announcements")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Policy")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Adobe Acrobat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Scenarios")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-file-contract"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Training")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "far fa-file-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("LMS")]), _vm._v(" "), _c('span', {
    staticClass: "arrow invisible"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-graduation-cap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("HFAI")]), _vm._v(" "), _c('span', {
    staticClass: "arrow invisible"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/ai.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Recipients")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("Reports"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title title_new"
  }, [_c('small', [_vm._v("New")]), _vm._v("Management Reports")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title title_new"
  }, [_c('small', [_vm._v("New")]), _vm._v("Vulnerability Reports")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "Virtual Cyber Risk Officer"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("vCRO"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "Gamification"
    }
  }, [_c('span', {
    staticClass: "title title_new"
  }, [_c('small', [_vm._v("New")]), _vm._v(" Gamification Engine")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "sidebar-user-portal",
      "href": "javascript:;",
      "title": "User Portal"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("User Portal")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "sidebar-user-portal",
      "href": "javascript:;",
      "title": "User Portal"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("User Portal - V2"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "sidebar-user-portal",
      "href": "javascript:;",
      "title": "Team Portal"
    }
  }, [_c('span', {
    staticClass: "title title_sup"
  }, [_vm._v("Team Portal "), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("IP Infomation")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-map-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Active Directory")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-folder"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Azure Active Dir")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-folder"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-644abc84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/sidebar.vue
// module id = 1579
// module chunks = 32